import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import b_ from 'b_';
import { TTitle } from '../Text/Text';
import Button from '../Button';
import FuseButton from '../FuseControls/FuseButton';
import { isFuse5Enabled } from '../../fuseFeatureFlag';
import './Box.css';
import './Box.new.css';

const defaultBlock = b_.lock('Box');
const newBlock = b_.lock('Fuse5Box');

export default function Box({
    className,
    titleClassName,
    contentClassName,
    title,
    children,
    onClose,
    theme = 'default',
    noPadding,
    ...otherProps
}) {
    const block = isFuse5Enabled() ? newBlock : defaultBlock;
    const ButtonComponent = isFuse5Enabled() ? FuseButton : Button;
    const buttonProps = isFuse5Enabled() ? {
        color: FuseButton.color.BLACK,
        qa: 'box_btn_close',
    } : {
        raised: true,
        closeBox: true,
    };

    return <div
        className={cn(block({ theme }), className)}
        {...otherProps}
    >
        {title ? <TTitle className={cn(block('Title'), titleClassName)}>
            {title}
            {onClose ? <ButtonComponent
                className={block('Close')}
                icon="close"
                onClick={onClose}
                {...buttonProps}
            /> : null}
        </TTitle> : null}
        <div className={cn(block('Content', { noPadding }), contentClassName)}>{children}</div>
    </div>;
}

Box.propTypes = {
    title: PropTypes.node,
    theme: PropTypes.string,
    titleClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    onClose: PropTypes.func,
    noPadding: PropTypes.bool,
};
